module.exports = __webpack_public_path__ + "static/media/image (21).78e70c6c.jpg";